<p-dialog
    header="Change Client"
    [modal]="true"
    [style]="{ width: '40rem' }"
    [visible]="true"
    (onHide)="closeDialog()"
    [closable]="false"
>
    <div class="flex flex-row gap-4 w-full mb-4 mt-2">
        <div class="flex flex-row gap-2 align-items-center">
            <label class="">Enrollment: </label>
            <p-select
                [options]="subscriptionFilters"
                [(ngModel)]="subscriptionFilter"
                (onChange)="updateFilters()"
                optionLabel="label"
                optionValue="value"
                placeholder="Select Enrollment"
            >
            </p-select>
        </div>

        <div class="flex flex-row gap-2 align-items-center">
            <label class="">Status: </label>
            <p-select
                [options]="statusFilters"
                [(ngModel)]="statusFilter"
                (onChange)="updateFilters()"
                optionLabel="label"
                optionValue="value"
                placeholder="Status"
            >
            </p-select>
        </div>
    </div>

    <div class="flex items-center gap-4 mb-4">
        <p-listbox
            [options]="visibleData"
            [(ngModel)]="selectedClient"
            [filter]="true"
            [filterPlaceHolder]="'Search'"
            [autoOptionFocus]="true"
            [focusOnHover]="false"
            [emptyMessage]="'No results found'"
            optionLabel="clientFullname"
            class="w-full"
            scrollHeight="300px"
        >
            <ng-template let-client pTemplate="item">
                <div class="flex flex-row w-full justify-content-between">
                    <div class="flex flex-column gap-1">
                        <span>{{ client.clientFullname }}</span>
                        <span class="text-sm opacity-70">{{ client.clientShortName }}</span>
                    </div>

                    <div class="flex flex-column gap-1 align-items-end">
                        <span class="opacity-70 text-sm">{{ client.subscriptionName }}</span>
                        <span class="text-sm opacity-70">{{ client.dataInstance }}</span>
                    </div>
                </div>
            </ng-template>
        </p-listbox>
    </div>

    <div class="flex flex-row w-full justify-content-end gap-2">
        <p-button label="Cancel" severity="secondary" (click)="closeDialog()"> </p-button>

        <p-button
            label="Change Client"
            [disabled]="!selectedClient"
            [loading]="savingClientChange"
            (click)="setClient()"
        >
        </p-button>
    </div>
</p-dialog>
